<script lang="ts">
	import { onMount, setContext } from 'svelte';
	import { goto } from '$app/navigation';
	import { Toaster } from 'svelte-sonner';
	import i18n, { initI18n } from '$lib/i18n';
	import { getSessionUser } from '$lib/apis/auths';
	import { user } from '$lib/stores';
	import Spinner from '$lib/components/common/Spinner.svelte';
	import '../tailwind.css';
	import '../app.css';
	import 'tippy.js/dist/tippy.css';

	setContext('i18n', i18n);
	let loaded = false;
	onMount(async () => {
		await initI18n('zh-CN');
		if (localStorage.token) {
			try {
				user.set(await getSessionUser(localStorage.token));
			} catch {
				localStorage.removeItem('token');
				user.set(null);
				await goto('/auth');
			}
		}
		loaded = true;
	});
</script>

<svelte:head><title>计量平台</title></svelte:head>
<Toaster position="top-right" richColors />
{#if loaded}<slot />{:else}
	<div class="flex h-screen items-center justify-center"><Spinner className="size-5" /></div>
{/if}
